import {EmptyStringValidatorDirective} from './universal/universal.directive';
import { NgModule } from '@angular/core';

import { CreditCardValidatorDirective } from './creditcard/creditcard.directive';
import { EmailValidatorDirective } from './email/email.directive';
import {
    IsInRangeValidatorDirective, IsNumberValidatorDirective,
    MaxValidatorDirective, MinValidatorDirective, WhiteSpaceValidatorDirective
} from './universal/universal.directive';
import { PasswordValidatorDirective } from './password/password.directive';
import { PhoneValidatorDirective, PossiblePhoneValidatorDirective, CountryCodeValidatorDirective } from './phone/phone.directive';


export class ValidatorsModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [CreditCardValidatorDirective,
        EmailValidatorDirective,
        PasswordValidatorDirective,
        IsInRangeValidatorDirective,
        IsNumberValidatorDirective,
        MaxValidatorDirective,
        MinValidatorDirective,
        WhiteSpaceValidatorDirective,
        PhoneValidatorDirective,
        PossiblePhoneValidatorDirective,
        EmptyStringValidatorDirective,
        CountryCodeValidatorDirective],
    exports: [CreditCardValidatorDirective,
        EmailValidatorDirective,
        PasswordValidatorDirective,
        IsInRangeValidatorDirective,
        IsNumberValidatorDirective,
        MaxValidatorDirective,
        MinValidatorDirective,
        WhiteSpaceValidatorDirective,
        PhoneValidatorDirective,
        PossiblePhoneValidatorDirective,
        EmptyStringValidatorDirective,
        CountryCodeValidatorDirective]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
